import { styled } from '@mui/material/styles';
import Container from '@mui/material/Container';

export const PageContainer = styled(Container)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '25vh',
});

export const TableContainer = styled('div')({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  alignItems: 'stretch',
});
